
import makerjs from "makerjs";
/**
 * 计算劣弧对应的圆心坐标
 * @param {Array} point - 弦端点坐标 [x, y]
 * @param {number} chordLength - 弦长
 * @param {number} radius - 圆半径
 * @returns {Array} 圆心坐标 [x, y]
 */
 function calculateArcCenter(point, chordLength, radius) {
  // 参数校验
  if (radius <= 0 || chordLength <= 0 || chordLength > 2*radius) {
      throw new Error('参数错误：半径需为正数且弦长不超过直径');
  }

  const [x1, y1] = point;
  const halfChord = chordLength / 2;
  const d = Math.sqrt(radius*radius - halfChord*halfChord); // 弦心距
  
  // 计算弦的垂直方向向量（逆时针旋转90度）
  const dx = y1;
  const dy = -x1;
  const length = Math.sqrt(dx*dx + dy*dy);
  const nx = dx / length; // 单位法向量x
  const ny = dy / length; // 单位法向量y

  // 劣弧圆心位于端点逆时针方向（确保劣弧特性）
  return [
      x1 + d * nx,
      y1 + d * ny
  ];
}

/**
 * 计算两点间的弦长
 * @param {Object} p1 - 第一个点坐标 {x, y}
 * @param {Object} p2 - 第二个点坐标 {x, y}
 * @returns {number} 弦长值
 */
 function calculateChordLength(p1, p2) {
  const dx = p2.x - p1.x;
  const dy = p2.y - p1.y;
  return Math.sqrt(dx*dx + dy*dy);
}
//已知劣弧上两点坐标及半径，求圆心坐标劣弧中心点坐标。
function optimizedArcMidpoint(start, end, radius) {
  // 1. 预计算差值避免重复计算
  const dx = end.x - start.x;
  const dy = end.y - start.y;
  const dSquared = dx * dx + dy * dy;
  
  // 快速检查半径有效性
  if (dSquared > 4 * radius * radius) return null; // 使用平方比较避免开方运算

  // 2. 计算中点（仅需一次加法运算）
  const midX = (start.x + end.x) * 0.5;
  const midY = (start.y + end.y) * 0.5;

  // 3. 计算垂直向量（优化单位化过程）
  const invD = 1 / Math.sqrt(dSquared);
  const ux = dy * invD;  // 单位垂直向量x分量
  const uy = -dx * invD; // 单位垂直向量y分量

  // 4. 计算圆心（单解模式，直接选择劣弧圆心）
  const h = Math.sqrt(radius * radius - dSquared * 0.25);
  const center = {
      x: midX + h * ux,
      y: midY + h * uy
  };

  // 5. 向量法计算中点（优化单位化过程）
  const v1x = start.x - center.x;
  const v1y = start.y - center.y;
  const v2x = end.x - center.x;
  const v2y = end.y - center.y;
  
  // 单位向量相加
  const sumX = v1x + v2x;
  const sumY = v1y + v2y;
  const invLen = radius / Math.sqrt(sumX * sumX + sumY * sumY);
  
  return {
      x: center.x + sumX * invLen,
      y: center.y + sumY * invLen
  };
}

/**
 * 已知 弦长 半径 其中一点坐标，计算弦上另一点坐标
 * @param {number} radius - 圆半径
 * @param {number} chordLength - 弦长
 * @param {Object} knownPoint - 已知点坐标 {x, y}
 * @param {Object} center - 圆心坐标 {x, y} (默认为原点)
 * @returns {Array} 返回两个可能的解(对称点)
 */
 function findChordPoint(radius, chordLength, knownPoint, center = {x:0, y:0}) {
  // 1. 参数校验
  if (chordLength > 2 * radius) {
      throw new Error("弦长不能超过直径长度");
  }

  // 2. 计算已知点到圆心的距离
  const dx = knownPoint.x - center.x;
  const dy = knownPoint.y - center.y;
  const d = Math.sqrt(dx*dx + dy*dy);

  // 3. 计算弦心距(垂直距离)
  const h = Math.sqrt(radius*radius - (chordLength/2)**2);

  // 4. 计算弦的方向向量
  const vx = -dy; // 垂直向量
  const vy = dx;
  const len = Math.sqrt(vx*vx + vy*vy);
  const unitX = vx / len;
  const unitY = vy / len;

  // 5. 计算两个对称解
  const point1 = {
      x: center.x + (h * unitX) + (chordLength/2) * (dx/d),
      y: center.y + (h * unitY) + (chordLength/2) * (dy/d)
  };

  const point2 = {
      x: center.x - (h * unitX) + (chordLength/2) * (dx/d),
      y: center.y - (h * unitY) + (chordLength/2) * (dy/d)
  };

  return [point1, point2];
}


function C37(model,zoom,Param,fixedParam){
  //w,h,w1,w2
  console.log("Param==",Param[0].param);
  console.log("Param==",Param[1].param);
  console.log("Param==",Param);
    var plate=model.plate,markers=model.markers,myZoom=zoom*1,
    A = Param[0].param,B = Param[1].param, C = Param[2].param,D = Param[3].param,R = Param[4].param,R1 = Param[5].param,
      //  plate = model.plate, markers = model.markers,
       markShift = fixedParam.markShift*1, markShiftTwo = fixedParam.markShiftTwo*1,
       markShiftThree = fixedParam.markShiftThree*1, markShiftFour = fixedParam.markShiftFour*1, markHolesOneD = fixedParam.markHolesOneD*1,

       a = A * 1 * myZoom,
       b = B * 1 * myZoom,
       c = C * 1 * myZoom,
       d = D * 1 * myZoom,
       r = R * 1 * myZoom,//角度
       r1 = R1 * 1 * myZoom,

       radian=(180-r)*(Math.PI/180),
      //  radian=180-r,
       // x0 = X*1*myZoom,
       // y0 = Y*1*myZoom;
       
       rh=a*Math.sin(radian),rw=a*Math.cos(radian),
      //  rh0=w/5*Math.sin(radian),rw0=w/5*Math.cos(radian),  
      w=c+rw,h=rh,
       // x0 = X*1*myZoom,
       // y0 = Y*1*myZoom;


       
       
       glassH = h, glassW = w;
       console.log("radian=",radian);
       // 示例测试
const endpoint = [rw+c, 0];  // 弦端点
const chordLen = d;       // 弦长
const radius = r1;         // 半径
console.log('劣弧端点坐标:', endpoint);
const centers = calculateArcCenter(endpoint, chordLen, radius);
    console.log('劣弧圆心坐标:', centers); // 输出: [3, 4]
       
          
// 示例用法
const chordLength = d;
const knownPoint = {x: rw+c, y: 0};
const center = {x: centers[0], y: centers[1]};

const solutions = findChordPoint(radius, chordLength, knownPoint, center);
console.log("解1:", solutions[0]);
console.log("解2:", solutions[1]);
if(solutions[0].x>=c){
var x2=solutions[0].x,y2=solutions[0].y;
}else if(solutions[1].x>=c){
  var x2=solutions[1].x,y2=solutions[1].y;
}
var x0 = rw, x1 = 0, x3 = w, y0 = 0, y1 = rh,  y3 = 0;
// const p1 = { x: x1, y: y1 };
// const p2 = { x: x2, y: y2 };
// // const arcLength=h2;
// var L=calculateChordLength(p1, p2);
// // L：弦长（两点间距离）
// // h：拱高（弦中心点到弧的垂直距离）
// var r = (L*L + 4*h2*h2)/(8*h2);
// // var r=calculateRadius(p1, p2, arcLength);
// console.log("RRRR===",r);
// const start = { x: x1, y: y1 };
// const end = { x: x2, y: y2 };
// const radius = r;
// // const midpoint = calculateArcMidpoint(start, end, radius);
// const midpoint =optimizedArcMidpoint(start, end, radius);
// console.log("输出劣弧中点坐标start=",start); // 输出劣弧中点坐标
// console.log("输出劣弧中点坐标end=",end); // 输出劣弧中点坐标
// console.log("输出劣弧中点坐标=",midpoint); // 输出劣弧中点坐标
//       //  var aa=Circle_Center(x1,y1,x2,y2,r);
//       //  console.log("aa====",aa);
//       var xm=midpoint.x,ym=midpoint.y;
      
// console.log("输出劣弧中点坐标xm,ym=",xm,ym); // 输出劣弧中点坐标

// //计算中点坐标
// const mx = (x1 + x2) / 2;
//             const my = (y1 + y2) / 2;

   if (a !== 0) {
       var TxtA = A;
   } if (b !== 0) {
    var TxtB = B;
} if (c !== 0) {
  var TxtC = C;
}if (d !== 0) {
  var TxtD = D;
}if (r !== 0) {
  var TxtR = R;
}if (r1 !== 0) {
  var TxtR1 = R1;
}



   var drawAbnormalShapeC37 = {
       paths: {
        "LeftLine": new makerjs.paths.Line([x0, y0], [x1, y1]),
        "TopLine": new makerjs.paths.Line([x1,y1], [x2,y2]),
        "RightArcLine": new makerjs.paths.Arc([x2, y2], [x3, y3], r1, false, false),
        "BottomLine": new makerjs.paths.Line([x3, y3], [x0, y0]),
       }
   };
  //  var drawAbnormalShapeC37MarkH1 = {
  //      paths: {
  //       "LeftLine": new makerjs.paths.Line([x0 - markShift, y0], [x0 - markShift, y1]),
  //       "LeftShortUpline": new makerjs.paths.Line([x1, y1], [x0 - 2 * markShift, y1]),
  //       "LeftShortDnline": new makerjs.paths.Line([x0, y0], [x0 - 2 * markShift, y0]),
  //      }
  //  };
  //  var drawAbnormalShapeC37MarkH2 = {
  //      paths: {
  //       "LeftLine": new makerjs.paths.Line([xm, ym], [mx, my]),
  //       // "UpShortLfline": new makerjs.paths.Line([x1, y2], [x1, y2 + 2 * markShift]),
  //       // "UpShortRTline": new makerjs.paths.Line([x2, y2], [x2, y2 + 2 * markShift]),
  //      }
  //  };
  //  var drawAbnormalShapeC37MarkH = {
  //      paths: {
  //       "RightLine": new makerjs.paths.Line([x3+ markShift, y3], [x3+ markShift, y2]),
  //       "RightShortUpline": new makerjs.paths.Line([x3, y2], [x3+ 2 * markShift, y2]),
  //       "RightShortDnline": new makerjs.paths.Line([x3, y3], [x3+ 2 * markShift, y3]),
  //      }
  //  };
  //  var drawAbnormalShapeC37MarkW = {
  //      paths: {
  //       "BottomLine": new makerjs.paths.Line([x0, y0 - markShift], [x3, y3 - markShift]),
  //       "BotmShortLfline": new makerjs.paths.Line([x0, y0], [x0, y0 - 2 * markShift]),
  //       "BotmShortRTline": new makerjs.paths.Line([x3, y3], [x3, y3 - 2 * markShift]),
  //      }
  // //  };  
  //  };
  //  makerjs.model.addCaption(drawAbnormalShapeC37MarkW, TxtW, [x0, y0 - 2 * markShift], [x3, y3 - 2 * markShift]);//长度文字  
  //  makerjs.model.addCaption(drawAbnormalShapeC37MarkH2, TxtH2, [mx, my-2*markShift], [mx+2*markShift, my-2*markShift]);//长度文字
  //  makerjs.model.addCaption(drawAbnormalShapeC37MarkH, TxtH, [x3 + 2 * markShift, y2], [x3 + 2 * markShift, y3]);//宽度文字
  //  makerjs.model.addCaption(drawAbnormalShapeC37MarkH1, TxtH1, [x0 - 2 * markShift, y0], [x0 - 2 * markShift, y1]);//宽度文字
   
  plate={
    models: {
      drawAbnormalShapeC37: drawAbnormalShapeC37,
      }
    };
    markers={
      models: {
        drawAbnormalShapeC37: drawAbnormalShapeC37,
        // drawAbnormalShapeC37MarkH2: drawAbnormalShapeC37MarkH2,
        // drawAbnormalShapeC37MarkH1: drawAbnormalShapeC37MarkH1,
        // drawAbnormalShapeC37MarkH:drawAbnormalShapeC37MarkH,
        // drawAbnormalShapeC37MarkW:drawAbnormalShapeC37MarkW
        }
      };
    
   /*****************************************************************************/
   //return { plate, markers, glassW, glassH }
 
    return{w,h,plate, markers} 
};


export default C37;